import React from "react";
import Modal from "react-bootstrap/Modal";
import AvatarEditor from "react-avatar-editor";
import BubbleSvgButton from "../../pages/sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const ImageUploadModals = ({
  // Cropper modal props
  showCropper,
  imageSrc,
  editor,
  setEditor,
  scale,
  setScale,
  handleCropSave,
  handleCropCancel,
  communityName,
  
  // Edit choice modal props
  showEditChoiceModal,
  setShowEditChoiceModal,
  handleEditChoice,
  fileInputRef,
  setIsProgrammaticUpload,
}) => {
  return (
    <>
      {/* Cropper Modal */}
      <Modal show={showCropper} centered>
        <Modal.Header style={{ justifyContent: "center" }}>
          <Modal.Title style={{ fontFamily: "Graphik Medium" }}>{`Add profile photo / logo`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {imageSrc && (
            <div style={{ textAlign: "center" }}>
              <AvatarEditor
                ref={setEditor}
                image={imageSrc}
                width={200}
                height={200}
                border={50}
                borderRadius={100} // Makes the crop area a circle
                color={[255, 255, 255, 0.6]}
                scale={scale}
                rotate={0}
              />
              <input
                type="range"
                min="1"
                max="3"
                step="0.01"
                value={scale}
                onChange={(e) => setScale(parseFloat(e.target.value))}
                style={{ width: 200, marginTop: 10 }}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center" }}>
          <BubbleSvgButton
            className="imageCropButtons"
            text="Cancel"
            variant="black"
            onClick={handleCropCancel}
            mainDivStyle={{ width: "120px", height: "40px" }}
            containerStyling={{
              justifyContent: "center",
              padding: 0,
            }}
          />
          <BubbleSvgButton
            className="imageCropButtons"
            text="Save Crop"
            variant="green"
            onClick={handleCropSave}
            mainDivStyle={{ width: "120px", height: "40px" }}
            containerStyling={{
              justifyContent: "center",
              padding: 0,
            }}
          />
        </Modal.Footer>
      </Modal>

      {/* Edit or upload new photo modal if logo exists */}
      <Modal
        show={showEditChoiceModal}
        centered
        onHide={() => setShowEditChoiceModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className='uploadImgModalTitle'>Edit Community Logo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="uploadImgModalSubTitle">Would you like to edit your existing photo or upload a new one?</p>
          <div className="editCommunityBtnsWrapper">
            <BubbleSvgButton
              text="Edit Existing Photo"
              type="button"
              variant="black"
              onClick={() => handleEditChoice("edit")}
              containerStyling={{ justifyContent: "center", padding: 0 }}
            />
            <BubbleSvgButton
              text="Upload New Photo"
              type="button"
              variant="green"
              onClick={() => {
                setIsProgrammaticUpload(true);
                fileInputRef.current?.click();
                setShowEditChoiceModal(false);
              }}
              containerStyling={{ justifyContent: "center", padding: 0 }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImageUploadModals; 